'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TideArrow = require('./TideArrow');

var _TideArrow2 = _interopRequireDefault(_TideArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TideArrow2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TideArrow/index.js
// module id = 691
// module chunks = 11